import { ScenarioWrapper, ScenarioScenario, ScenarioCriteria } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Commande REST de recherche des scenarii
 */
export class FindScenariiCommand extends WizCommand<ScenarioWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  

    const wrapper: ScenarioWrapper = new ScenarioWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new ScenarioScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();

    wrapper.criteria = new ScenarioCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    this.configureRemote(ExternalAPI.SCENARIO_API, wrapper);
  }

  wizResult() {
    super.wizResult();
    if (!!this.result?.entities) {
      this.model.scenarioEngine.buildMap(this.result.entities);
    }
  }
}
